import { render, staticRenderFns } from "./Dialog.vue?vue&type=template&id=bcfa21be&scoped=true"
import script from "./Dialog.vue?vue&type=script&lang=js"
export * from "./Dialog.vue?vue&type=script&lang=js"
import style0 from "./Dialog.vue?vue&type=style&index=0&id=bcfa21be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcfa21be",
  null
  
)

export default component.exports